export default {
  '报表类型': '报表类型',
  '方案配置': '方案配置',
  '添加方案': '添加方案',
  '将报表方案配置至相应设备类型': '将报表方案配置至相应设备类型',
  '手机/平板': '手机/平板',
  '电脑': '电脑',
  '剩余可用字段': '剩余可用字段',
  '当前使用字段': '当前使用字段',
  '可长按拖动排序': '可长按拖动排序',
  '基础': '基础',
  '提示': '提示',
  '取消': '取消',
  '确定': '确定',
  '重命名': '重命名',
  '请输入方案名': '请输入方案名',
  '当前方案正在使用中，无法删除！': '当前方案正在使用中，无法删除！',
  '确认删除该方案吗？': '确认删除该方案吗？',
  '确认将该方案应用于电脑端吗？': '确认将该方案应用于电脑端吗？',
  '确认将该方案应用于手机/平板端吗？': '确认将该方案应用于手机/平板端吗？',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗?': '未保存方案的情况下退出会丢失已操作的记录。确认退出吗?',
  '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存': '执行该操作会刷新页面,请确认右侧方案字段配置操作已保存',
  '确定删除后会刷新页面，请确认右侧字段已保存': '确定删除后会刷新页面，请确认右侧字段已保存',
  '未保存方案的情况下退出会丢失已操作的记录。确认退出吗？': '未保存方案的情况下退出会丢失已操作的记录。确认退出吗？',
  '确定命名后会刷新页面，请确认右侧字段已保存': '确定命名后会刷新页面，请确认右侧字段已保存',
  '确定应用后会刷新页面，请确认右侧字段已保存': '确定应用后会刷新页面，请确认右侧字段已保存',
  '报表方案配置': '报表方案配置',
  '方案保存成功': '方案保存成功',
  '方案重命名成功': '方案重命名成功',
  '设备类型激活成功': '设备类型激活成功',
  '删除方案成功': '删除方案成功',
  '添加成功': '添加成功',
  '保存': '保存'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/report.js